import { iaRa } from 'lib/helpers/utility';

const getCptCodes = (procedures = []) => {
  const cptCodes = iaRa(procedures).map((proc) => proc.procedure_code);

  return cptCodes.filter(Boolean).join(', ');
};
export default getCptCodes;
